<template>
    <div class="wrap-input" :class="customClass">
        <!-- <label class="label"
               :class="{'error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}">
            {{label}}
        </label> -->
        <div :class="{'input-box-error': !isFirstSave && isShowErrorLbl && !errorInfo.isValid}" @click="trackEvent()">
            <b-dropdown :text="textValueDropdown"
                        class="ddl-input"
                        variant="ddl-input"
                        menu-class="ddl-menu">
                <b-dropdown-item v-for="(v,k) in dropdownList"
                                 :key="k"
                                 @click="onChange(v)">
                    {{v.name}}
                </b-dropdown-item>
            </b-dropdown>
        </div>
        <div class="error-text"
             v-if="isShowErrorLbl"
             v-show="!isFirstSave && !errorInfo.isValid">
            {{errorInfo.msg}}
        </div>
    </div>
</template>
<script>
import Util from "@/helper/Utility.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
/**
 * Property
 * @property {Object} inputLbl (required) Text for component.
 * @property {Boolean} isFirstSave (required) Show/Hide Error after save.
 * @property {Boolean} isShowErrorLbl (optional) Show/Hide Error label.
 * @property {Object} errorInfo (optional) Validate result. example : { isValid: true, msg: '',}
 * @property {String} addClass (optional) Add css class.
 * @property {Array} itemList (required) item list in dropdown. example : [{ value: '1', text: 'a'}]
 */
export default {
    name: "Dropdown",
    props: {
        //v-model
        value: String,
        //props
        inputLbl: Object,
        isFirstSave: Boolean,
        isShowErrorLbl: Boolean,
        errorInfo: Object,
        addClass: String,
        itemList: Array,
        setCountry: Object,
        //trackEvent: Boolean
    },
    data: function() {
        return {
            label: '',
            content: this.value,
            customClass: '',

            textValueDropdown: '',
            dropdownList: [],
            
            tracking: new TrackingService(this),
        };
    },
    mounted: function() {
        this.label = this.inputLbl.name || 'Label';
        this.customClass = this.addClass || '';
        this.dropdownList = this.itemList;
        this.textValueDropdown = this.inputLbl.defaultText;
        this.initialDefaultValue();
        this.validateInput();

        if (!Util.isEmptyStr(this.setCountry)) {
            this.onChange(this.setCountry);
        }

    },
    methods: {
        initialDefaultValue: function() {
            if (Util.isEmptyStr(this.setCountry)) {
                return;
            }

            // for (var i of this.dropdownList) {
            //     if (i.value == this.value) {
            //         this.onChange(i);
            //         break;
            //     }
            // }
        },
        validateInput: function() {
            if(!this.inputLbl) return;
            //Set default.
            this.errorInfo.isValid = true;
            this.errorInfo.msg = '';
            //Required
            if(this.inputLbl.required && Util.isEmptyStr(this.content)) {
                this.errorInfo.isValid = false;
                this.errorInfo.msg = this.inputLbl.required;
                return;
            }
        },
        onChange: function(selected) {

           
            this.content = selected.id;
            this.textValueDropdown = selected.name;

            this.validateInput();
            this.$emit('input', selected);
        },

        trackEvent: function () {
           this.tracking.event("regis_user_info", "click_country_box");
        }
    },
}
</script>
<style lang="scss" scoped>
    $url-dropdown-icon: url('../../../assets/icon/checkbox_active.png');
    @import "@/style/Input/Dropdown.scss";
</style>
<style lang="scss">
    @import "@/style/Input/Text.scss";
    
    .wrap-input {
        @extend %input-base; 
    }
</style>
